import moment from 'moment'
export default {
  className: 'order',
  title: '自提订单',
  render: (record) => {
    return record.orderId
  },
  perPage: 10,
  mixin: {
    fields: [
      {
        name: 'orderId'
      },
      {
        name: 'user',
        note: '用户',
        searchKey: ['phone', 'nickName'],
        render: (record) => {
          if (record && record.user) {
            return `${record.user.nickName}(${record.user.phone})`
          }
        },
        listWhere: (where) => {
          where.isAdmin = {
            $ne: true
          }
        }
      },
      {
        name: 'goodsObj',
        note: '商品信息',
        render: (record) => {
          let string = ''
          if (record.goodsObj) {
            for (let i in record.goodsObj) {
              let item = record.goodsObj[i]
              if (Number(i) === record.goodsObj.length - 1) {
                string += `${item.name}(${item.count})`
              } else {
                string += `${item.name}(${item.count})、`
              }
            }
          }
          return string
        }
      },
      {
        name: 'money',
        note: '应付金额',
        width: 120
      },
      {
        name: 'relMoney',
        note: '实付金额',
        width: 120
      },
      'address',
      'createdAt',
      'updatedAt'
    ],
    search: [
      'orderId',
      'user',
      'address'
    ]
  },
  action: {
    delete: false,
    create: false,
    edit: false,
    export: {
      type: 'list',
      icon: 'export',
      text: '导出',
      component: 'akModelExporter',
      events: {
        exportComplete: () => {} // 导出完成后触发的事件
      }
    }
    // view: {
    //   type: 'row',
    //   text: '查看',
    //   component: myViewPage
    // }
    // send: {
    //   type: 'row',
    //   text: '到货',
    //   title: '确认到货',
    //   hidden: ({ record }) => {
    //     return record && (record.isInPlace || record.state === 'completed')
    //   },
    //   callback: async ({ vm, record }) => {
    //     await vm.confirm('警告', '您确定此订单已到货?')
    //     await vm.$tkParse.put(`/classes/order/${record.objectId}`, {
    //       isInPlace: true,
    //       state: 'completed',
    //       goodsInPlaceAt: new Date().toISOString(),
    //       timeDone: new Date().toISOString()
    //     })
    //     try {
    //       vm.$notification['success']({
    //         message: '操作成功'
    //       })
    //       vm.refresh()
    //     } catch (e) {
    //       vm.$notification['error']({
    //         message: '网络错误,请重试'
    //       })
    //     }
    //   }
    // }
  },
  hooks: {
    async beforeFetch ({ where }) {
      where.type = 'shopping'
      where.deliveryMode = 'pickup'
      where.state = {
        $nin: ['bePaid', 'refund']
      }
      // moment昨日开始时间与昨日的结束时间
      let yesterday = moment().subtract(1, 'days').startOf('day').toISOString()
      let yesterdayEnd = moment().subtract(1, 'days').endOf('day').toISOString()
      where.createdAt = {
        $gte: yesterday,
        $lte: yesterdayEnd
      }
    }
  }
}
